import { changePassword } from '@/service/login/login'
import { ElMessage } from 'element-plus'
import { ref } from 'vue'

export function createFormConfig(params: any) {
  const { loginStore } = params
  const formData = ref({
    newPassword: '',
    confirmPassword: ''
  })
  const formRef = ref()
  const formItems = [
    {
      path: 'newPassword',
      placeholder: '请输入新密码',
      type: 'password',
      showPasswordOn: 'mousedown',
      size: 'large',
      bordered: true,
      tip: `* 密码必须为8~16位且包含大小写字母、数字和英文标点符号中的至少三类；
* 密码不得为连续字符（如：123、abc）或使用重复字符（111、aaa）。`
    },
    {
      path: 'confirmPassword',
      placeholder: '再次确认密码',
      type: 'password',
      showPasswordOn: 'mousedown',
      size: 'large',
      bordered: true
    }
  ]

  const handleSubmit = async () => {
    if (formData.value.newPassword !== formData.value.confirmPassword) {
      ElMessage.warning('两次输入的密码不一致')
      return
    }

    const res = await loginStore.runWithUserInfoRefresh(() =>
      changePassword(formData.value)
    )
    if (res.data) {
      ElMessage.success('修改成功')
      loginStore.completeCurrentPostLoginReminder()
      formData.value = {
        newPassword: '',
        confirmPassword: ''
      }
    }
  }

  return {
    formItems,
    formRef,
    formData,
    handleSubmit
  }
}
